import { useLanguage } from "contexts/LanguageContext";
import Modal from "./Modal";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  deleteMessage: string;
  deleteWarning: string;
  danger?: boolean;
  zIndex?: number;
}

const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  deleteMessage,
  deleteWarning,
  danger = false,
  zIndex
}: ConfirmDeleteModalProps) => {
  const { t } = useLanguage();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="md"
      zIndex={zIndex}
    >
      <div className={`p-6 space-y-4 ${danger ? 'bg-red-50 dark:bg-red-900/20' : ''}`}>
        <div className="flex items-center">
          <div className="flex-shrink-0 mr-3">
            <ExclamationTriangleIcon className={`h-10 w-10 ${danger ? 'text-red-600 dark:text-red-400 animate-pulse' : 'text-red-500 dark:text-red-400'}`} />
          </div>
          <div className="flex-1">
            <p className={`${danger ? 'text-red-700 dark:text-red-300 font-bold text-lg' : 'text-red-600 dark:text-red-400 font-semibold'}`}> {deleteMessage} </p>
            <p className={`mt-2 ${danger ? 'text-red-600 dark:text-red-400 font-medium' : 'text-sm text-gray-500 dark:text-gray-400'}`}> {deleteWarning} </p>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-xs font-medium rounded-md bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600"
          >
            {t('common.actionsObject.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-xs font-medium rounded-md text-white ${
              danger 
                ? 'bg-red-700 hover:bg-red-800 dark:bg-red-600 dark:hover:bg-red-700 shadow-md' 
                : 'bg-red-600 hover:bg-red-700 dark:bg-red-500 dark:hover:bg-red-600'
            }`}
          >
            {danger ? 'Biztosan törlöm' : t('common.actionsObject.delete')}
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default ConfirmDeleteModal